
export interface IMenuItem {
    module?: Array<any>,
    type: string; // Possible values: link/dropDown/icon/separator/extLink
    name?: string; // Used as display text for item and title for separator type
    state?: string; // Router state
    icon?: string; // Material icon name
    tooltip?: string; // Tooltip text
    disabled?: boolean; // If true, item will not be appeared in sidenav.
    sub?: IChildItem[]; // Dropdown items
    badges?: IBadge[];
  }
  
  export interface IChildItem {
    type?: string;
    name: string; // Display text
    state?: string; // Router state
    icon?: string;
    module?: Array<any>,
    sub?: IChildItem[];
  }
  
  export interface IBadge {
    color: string; // primary/accent/warn/hex color codes(#fff000)
    value: string; // Display text
  }